export default __webpack_public_path__ + "static/image1-1ecc4e1a92a0481e79ba7b876cd27ff6.jpg";